function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowDimensions = exports.UseWindowDimensionsProvider = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _reactNativeOutsidePress = require("react-native-outside-press");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var WindowDimensionsContext = (0, _react.createContext)(0);
var UseWindowDimensionsProvider = exports.UseWindowDimensionsProvider = function UseWindowDimensionsProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(_reactNative.Dimensions.get('window').width),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _width = _useState2[0],
    _setWidth = _useState2[1];
  var _changeWidth = function _changeWidth() {
    _setWidth(_reactNative.Dimensions.get('window').width);
  };
  (0, _react.useEffect)(function () {
    var subscription;
    if (_reactNative.Platform.OS === 'web') {
      var _window;
      (_window = window) == null ? void 0 : _window.addEventListener == null ? void 0 : _window.addEventListener('resize', _changeWidth);
    } else {
      subscription = _reactNative.Dimensions.addEventListener('change', _changeWidth);
    }
    return function () {
      var _subscription;
      if (_reactNative.Platform.OS === 'web') {
        var _window2;
        (_window2 = window) == null ? void 0 : _window2.removeEventListener == null ? void 0 : _window2.removeEventListener('resize', _changeWidth);
      }
      (_subscription = subscription) == null ? void 0 : _subscription.remove();
    };
  }, []);
  return (0, _jsxRuntime.jsx)(WindowDimensionsContext.Provider, {
    value: _width,
    children: (0, _jsxRuntime.jsx)(_reactNativeOutsidePress.EventProvider, {
      children: children
    })
  });
};
var useWindowDimensions = exports.useWindowDimensions = function useWindowDimensions() {
  var width = (0, _react.useContext)(WindowDimensionsContext);
  return {
    width: width
  };
};